module.exports = __webpack_public_path__ + "static/media/userPermission.c26d508a.svg";